/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * AutoGPT Agent Server
 * This server is used to execute agents that are created by the AutoGPT system.
 * OpenAPI spec version: 0.1
 */

export type ProviderMetadataSupportedAuthTypesItem =
  (typeof ProviderMetadataSupportedAuthTypesItem)[keyof typeof ProviderMetadataSupportedAuthTypesItem];

export const ProviderMetadataSupportedAuthTypesItem = {
  api_key: "api_key",
  oauth2: "oauth2",
  user_password: "user_password",
  host_scoped: "host_scoped",
  device_code: "device_code",
} as const;
